// const KroVerifiedBadge: React.FC = () => {
//   return (
//     <div
//       className="flex items-center justify-center rounded-2xl bg-state-success-lighter px-2 py-[2px] text-body-sm font-medium leading-[16px] text-state-success-base">
//       Verified
//     </div>
//   );
// };

import { cn } from "common/utils/utils";

const KroCampaignStatusBadge = ({ status }: { status: string }) => {
  const statusText = {
    published: "Live",
    in_review: "In Review",
    rejected: "Rejected",
    draft: "Draft",
    suspended: "Suspended",
    ended: "Ended",
  };
  return (
    <div
      className={cn(
        "rounded-full px-2 py-[2px] text-[12px] font-inter font-medium leading-[16px] tracking-[0%]",
        status === "published" ? "bg-[#E0FAEC] text-[#1FC16B]" : "border border-stroke-soft-200 text-[#717784]",
        status === "published" ? "animate-pulse" : "",
        status === "in_review" && "bg-[#FFFBED] text-[#9D530F] border-none",
        status === "rejected" && "bg-[#FFE3E3] text-[#FF0000]",
        status === "draft" && "bg-[#F2F5F8] text-[#717784]",
        status === "suspended" && "bg-[#F5F5F5] text-[#717784]",
        status === "ended" && "bg-[#F5F5F5] text-[#717784]",
      )}>
      {statusText[status as keyof typeof statusText]}
    </div>
  );
};

const KroCategoryBadge: React.FC<{ category: string }> = ({ category }) => {
  return (
    <div
      className="rounded-2xl border-[0.8px] border-[#717784] px-2 py-[2px] text-body-sm font-medium leading-[16px] text-[#717784]">
      {category}
    </div>
  );
};

export { KroCategoryBadge, KroCampaignStatusBadge };
